import { Hide, HStack, Show, Spinner, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ActiveChat } from "../../../components/card/ActiveChat";
import { Empty } from "../../../components/card/Empty";
import { ListChat } from "../../../components/card/ListChat";
import { ProductParamInterface } from "../../../constants/Chat";
import { isUuid } from "../../../utils/helperFunction";
import MobileListChat from "../../../components/MobileListChat";

export const BuyerChat = () => {
  const [productParam, setProductParam] = useState<
    ProductParamInterface | undefined
  >(undefined);
  const [chatParams, setChatParams] = useState<string>("");
  const [selectedChat, setSelectedChat] = useState<string | number | undefined>(
    undefined
  );
  const [newSelectedChat, setNewSelectedChat] = useState<
    string | number | undefined
  >(undefined);
  const [chatLoading, setChatLoading] = useState<boolean>(false);
  const [isChange, setIsChange] = useState<boolean>(false);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const supplierId = queryParams.get("supplierId");
  const productId = queryParams.get("productId");
  const variantId = queryParams.get("variantId");
  const storePrefix = queryParams.get("storePrefix");
  const slug = queryParams.get("slug");

  useEffect(() => {
    let statusParams: boolean = !!supplierId && !!productId && !!variantId;

    if (statusParams) {
      setSelectedChat(supplierId?.toString());
      const prodParam: ProductParamInterface = {
        supplierId: supplierId,
        productId: productId,
        variantId: variantId,
        storePrefix: storePrefix || "",
      };
      setProductParam(prodParam);
      setNewSelectedChat(supplierId?.toString());
    }
  }, [productId, supplierId, variantId, storePrefix]);

  useEffect(() => {
    if (chatParams) {
      setProductParam(undefined);
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, [chatParams, selectedChat]);

  useEffect(() => {
    if (productParam && !chatLoading) {
      setSelectedChat(newSelectedChat);
    } else if (!productParam && !chatLoading) {
      setChatParams(selectedChat as string);
      setSelectedChat(newSelectedChat as string);
    } else {
      setChatParams(newSelectedChat as string);
      setSelectedChat(newSelectedChat);
      setChatLoading(false);
    }
  }, [newSelectedChat]);

  return (
    <HStack
      className="chat-page"
      w={"100%"}
      h={"calc(100dvh - 60px)"}
      align={"stretch"}
      gap={0}
      overflowY={"auto"}
    >
      <Show above="md">
        <ListChat
          onSelectedChat={(newChat) => {
            if (selectedChat !== newChat) {
              setSelectedChat(undefined);
              setChatLoading(true);
              setNewSelectedChat(newChat);
            }
          }}
        />
      </Show>
      {selectedChat ? (
        <ActiveChat
          clientRole="supplier"
          storePrefix={storePrefix}
          slug={slug}
          selectedChat={selectedChat}
          productParam={productParam}
          setSelectedChat={setSelectedChat}
          handleCloseChat={() => {
            setNewSelectedChat(undefined);
            setProductParam(undefined);
          }}
          onSendMessage={(id_chat: string) => {
            !isChange ? setIsChange(true) : setIsChange(false);

            if (!isUuid(selectedChat as string) && isUuid(id_chat)) {
              setSelectedChat(id_chat);
            }

            if (supplierId && productId && variantId && storePrefix && slug) {
              const newUrl = window.location.pathname;
              window.history.replaceState({}, "", newUrl);

              setProductParam(undefined);
            }
          }}
        />
      ) : chatLoading ? (
        <VStack
          w={{ base: "100%", md: "70%" }}
          h={"100%"}
          justify={"center"}
          align={"center"}
        >
          <Spinner size="xl" color="red.500" />
        </VStack>
      ) : (
        <VStack className="right-chat-layout" w={{ base: "100%", md: "70%" }}>
          <Show above="md">
            <Empty
              title={"Mulai Berinteraksi"}
              subtitle="Pilih chat anda terlebih dahulu dan mulai berinteraksi"
              w={"100%"}
              maxW={"300px"}
            />
          </Show>
          <Hide above="md">
            <MobileListChat
              onSelectedChat={(newChat) => {
                setSelectedChat(undefined);
                setChatLoading(true);
                setNewSelectedChat(newChat);
              }}
            />
          </Hide>
        </VStack>
      )}
    </HStack>
  );
};
